import React from 'react';
import { SmIcon, SmBadge } from '@smiles/smiles-react-design-system';

type TProps = {
  label?: string;
  className?: string;
};

export const RegisteredLabel = ({ label, className }: TProps) => {
  if (!label) return null;

  return (
    <SmBadge
      icon={<SmIcon name="error" size="small" type="two-tone" />}
      text={label}
      className={className}
    />
  );
};
